module.exports = __webpack_public_path__ + "0cc812f8c2992bf06a8d19fa1936c897.png";


//////////////////
// WEBPACK FOOTER
// ./img/downStock.png
// module id = 20
// module chunks = 9 13